import api from './api';

let _debounceTimers = {};

export const logAudit = (action, page, details = '') => {
  // Debounce page_view actions (same page within 5s)
  if (action === 'page_view') {
    const key = `${action}_${page}`;
    if (_debounceTimers[key]) return;
    _debounceTimers[key] = true;
    setTimeout(() => { delete _debounceTimers[key]; }, 5000);
  }

  api.post('/audit/log', { action, page, details }).catch(() => {});
};
